import { ZonedDateTime } from '@js-joda/core';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes, MediaTypes,
  nNumber,
  uNumber,
  uString,
  Uuid
} from '@hidat/huijs-common';
import { ResourceConfig, SearchFilterConfig } from '@hidat/huijs-resource';
import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  splixerFieldConfigs,
  splixerSystemFields
} from './splixer-fields.const';
import { MediaContentTypes } from './splixer-types';
import { SegmentConfig } from './segment.interface';
import { HashViews } from './hash-views';
import { SortOrder } from '@hidat/huijs-api';

export interface MediaRepoItem {
  id: number;
  duration: number;
  encoding: string;
  path?: uString;
  repo_path: uString;
  media_name: string;
}

export const MediaItemConfig = new ResourceConfig('MediaItem')
  .addFields(
    [
      splixerFieldConfigs.uid,
      new FieldConfig('contentType'),
      new FieldConfig('broadcastedAt', FieldDataTypes.DATETIME),
      new FieldConfig('duration', FieldDataTypes.INTEGER),
      new FieldConfig('items', FieldDataTypes.HASH),
      new FieldConfig('rawMeta', FieldDataTypes.HASH),
      new FieldConfig('traits', FieldDataTypes.HASH),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs['intId'],
    splixerFieldConfigs['status'],
    splixerFieldConfigs['channelId'],
    splixerFieldConfigs['stationId'],
    splixerFieldConfigs['showId'],
    splixerFieldConfigs['remoteId'],
    ...splixerSystemFields,
  ])
  .setSorts({
    broadcastedat: {
      dbName: 'broadcastedAt',
      defaultOrder: SortOrder.DESC,
    },
    createdat: {
      dbName: 'createdAt',
      defaultOrder: SortOrder.DESC,
    },
  })
  .setDefaultSort('broadcastedat-');

export const MediaItemFilterConfig = new SearchFilterConfig(SegmentConfig, {
  only: ['showId', 'status', 'channelId', 'stationId']
}).addRangeField('broadcastedAt', FieldDataTypes.DATE);


export interface MediaItemInterface extends SplixerResourceInterface<number> {
  uid: Uuid | undefined;
  tenantId: Uuid | undefined;
  stationId: uNumber;
  channelId: uNumber;
  showId: nNumber;

  contentType: MediaContentTypes | undefined;
  broadcastedAt: ZonedDateTime | undefined;
  duration: nNumber;

  // Media Items within the attached channels repository
  items: AnyHash | undefined;   //sb mediaUrls?
  rawMeta: AnyHash | undefined;
  traits: AnyHash | undefined;

  remoteId: nNumber;

  // What type of content is this
  mediaType?: MediaTypes;
}
